import { designTokens, reactIcons, Tooltip } from '@project44/manifest-ds';
import { DateFormat, formatDateTime } from '@project44/ui-utils';

import { scopedT } from '../../../utils/functions/scopedT';

interface DateTimeWindowProps {
  initialDateTime?: string;
  lastPlannedDateTime?: string;
  timeZone?: string;
}

const t = scopedT();

export const PlannedDateTooltip = ({
  initialDateTime,
  lastPlannedDateTime,
  timeZone,
}: DateTimeWindowProps) => {
  if (!initialDateTime || !lastPlannedDateTime) {
    return null;
  }

  const dateTimeTimezone = timeZone ? { timeZone } : {};

  const getFormattedDate = (date?: string) => {
    if (!date) {
      return null;
    }
    const monthDay = formatDateTime({
      dateTime: date,
      dateFormat: DateFormat.shortMonthDay,
      ...dateTimeTimezone,
    });

    const hourMinute = formatDateTime({
      dateTime: date,
      dateFormat: DateFormat.hourMinute,
      ...dateTimeTimezone,
    });

    const timezoneAbbreviation = formatDateTime({
      dateTime: new Date(),
      dateFormat: DateFormat.timezone,
      ...dateTimeTimezone,
    });

    return (
      <>
        {monthDay} &middot; {hourMinute} {timezoneAbbreviation}
      </>
    );
  };

  return (
    <Tooltip
      title={
        <>
          {t('plannedDateTooltip.carrierInitial')}:{' '}
          {getFormattedDate(initialDateTime)}
          <br />
          {t('plannedDateTooltip.carrierLatest')}:{' '}
          {getFormattedDate(lastPlannedDateTime)}
        </>
      }
    >
      <reactIcons.InfoCircled
        data-testid="info-icon"
        size="small"
        css={{
          fill: designTokens.colorTextTertiary,
          marginLeft: '$x-small',
          verticalAlign: 'text-top',
        }}
      />
    </Tooltip>
  );
};

export default PlannedDateTooltip;
